import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { CheckIcon, XIcon } from "lucide-react";

import { State } from "@/state";

export function AppTopbarLoadingSpinner() {
  const isMutating = State((state) => state.isMutating);
  const setIsMutating = State((state) => state.setIsMutating);
  const timerRef = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    if (isMutating === "error" || isMutating === "success") {
      timerRef.current = setTimeout(
        () => {
          setIsMutating(null);
        },
        isMutating === "success" ? 2000 : 1000,
      );
    } else if (isMutating === "in-flight") {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, [isMutating, setIsMutating]);

  return (
    <AnimatePresence mode="wait">
      {isMutating === "error" && (
        <motion.div
          key="error"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          style={{
            width: "16px",
            height: "16px",
          }}
        >
          <XIcon size={16} color="var(--destructive)" />
        </motion.div>
      )}
      {isMutating === "success" && (
        <motion.div
          key="success"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          style={{
            width: "16px",
            height: "16px",
          }}
        >
          <CheckIcon size={16} color="var(--muted-foreground)" />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
